import React from "react";

const LoadingButton = ({
    loading = false,
    loadingText = "Saving...",
    className = "",
    disabled = false,
    children,
    ...props
}) => {
    const buttonClassName = `${className} button_with_loader`.trim();

    return (
        <button
            {...props}
            className={buttonClassName}
            disabled={disabled || loading}
            aria-busy={loading}
        >
            {loading && <span className="btn_loader" aria-hidden="true"></span>}
            <span>{loading ? loadingText : children}</span>
        </button>
    );
};

export default LoadingButton;
